import numeral from "numeral"
function formatCurrency(number) {
    return numeral(number).format("0,0")
}

function formatNumber(number) {
    return numeral(number).format("0,0")
}

export { formatCurrency, formatNumber }